var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5C10.825 8.5 11.5 7.825 11.5 7V4C11.5 3.175 10.825 2.5 10 2.5C9.175 2.5 8.5 3.175 8.5 4V7C8.5 7.825 9.175 8.5 10 8.5Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.325 4.675C15.1 4.45 14.875 4.375 14.5 4.375C13.9 4.375 13.375 4.9 13.375 5.5C13.375 5.8 13.525 6.1 13.675 6.325C14.65 7.3 15.175 8.575 15.175 10C15.175 12.925 12.85 15.25 9.925 15.25C7 15.25 4.675 12.925 4.675 10C4.675 8.575 5.275 7.225 6.25 6.325C6.475 6.1 6.625 5.8 6.625 5.5C6.625 4.9 6.1 4.375 5.5 4.375C5.2 4.375 4.9 4.525 4.675 4.675C3.325 6.025 2.5 7.9 2.5 10C2.5 14.125 5.875 17.5 10 17.5C14.125 17.5 17.5 14.125 17.5 10C17.5 7.9 16.675 6.025 15.325 4.675Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutIcon);
export default __webpack_public_path__ + "static/media/signoutIcon.05c004d5112b84e33f17ae89ba7722a5.svg";
export { ForwardRef as ReactComponent };